import { SVGProps } from 'react'

export const GreenEllipse = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="11" cy="11.8909" r="10" strokeWidth="2" />
    </svg>
  )
}
